import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { selectImageByType } from 'src/utils/helpers';
import { INotificationsWindowInfo } from '@app/notifications/store/reducers/notifications.reducers';
import { NEW_PERSONAL_URL, ROUTES } from 'src/utils/constants';

@Component({
  selector: 'app-notification-window',
  templateUrl: './notification-window.component.html',
  styleUrls: ['./notification-window.component.scss'],
})
export class NotificationWindowComponent implements OnInit {
  @Input()
  notificationsInfo: INotificationsWindowInfo | null;
  @Output()
  closeWindow = new EventEmitter();
  newPersonalUrl = `${NEW_PERSONAL_URL}${ROUTES.NOTIFICATIONS}`;

  constructor(
  ) {}

  ngOnInit(): void {}

  selectItemImageByType = selectImageByType;

  seeAllNotifications = () => {
    this.closeWindow.emit();
  };
}
